import React, { useState } from "react";
import styled from "styled-components";
import Row from "./Row";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { NavLink } from "../types/nav";

const DEFAULT_LINKS: NavLink[] = [
  { label: "Home", to: "/#section-1" },
  { label: "Como funciona", to: "/#section-2" },
  { label: "Perguntas frequentes", to: "/#section-6" },
  { label: "Quanto custa", to: "/#section-7" },
];

const MenuContainer = styled.nav`
  padding: 20px;
  margin: auto;
  position: relative;

  @media (max-width: 576px) {
    padding: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`;

const MenuItem = styled(Link)`
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  text-align: center;
`;

const MenuIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 576px) {
    display: flex;
    font-size: 24px;
    font-weight: bold;
  }
`;

const CollapsibleMenu = styled.div<{ isOpen: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
  max-height: 100%;

  @media (max-width: 576px) {
    max-height: ${({ isOpen }) => (isOpen ? "300px" : "0")};
    padding: ${({ isOpen }) => (isOpen ? "20px" : "0")};
    background-color: #000;
  }
`;

interface MenuProps {
  links?: NavLink[];
}

const Menu: React.FC<MenuProps> = ({ links = DEFAULT_LINKS }) => {
  const [isOpen, setIsOpen] = useState(false);
  const cols = links.map(() => "auto").join(" ");

  return (
    <MenuContainer>
      <MenuIcon onClick={() => setIsOpen(!isOpen)}>
        <Icon icon="mdi:menu" width={32} height={32} color="#fff" />
      </MenuIcon>
      <CollapsibleMenu isOpen={isOpen}>
        <Row
          xs="auto"
          sm="auto"
          md={cols}
          lg={cols}
          xl={cols}
          gap="33px"
          style={{ minHeight: "60px", alignItems: "center" }}
        >
          {links.map((link) => (
            <MenuItem key={link.to} to={link.to}>
              {link.label}
            </MenuItem>
          ))}
        </Row>
      </CollapsibleMenu>
    </MenuContainer>
  );
};

export default Menu;
